import {apollo} from "@/apollo";
import gql from "graphql-tag";
import {eventBus} from "@/services/event-bus";
import utils from "@/services/utils";
import Party, {WriteParty} from "@/models/party";
import Activity from "@/models/activity";

class PartyService {
    async allTherapist() {
        try {
            let promise = await apollo.query({
                query: gql`query {
                    therapists{
                        id
                        name
                        surname
                        type
                        email
                        mobile
                        login
                        activities {
                            id
                            name
                            code
                        }
                    }
                }`
            });
            return (promise.data.therapists as any[]).map<Party>(it => new Party(it));
        } catch (e:any) {
            // eslint-disable-next-line no-console
            console.log(e);
            eventBus.$emit('error', e.message);
            throw e;
        }
    }

    async allPatients() {
        try {
            let promise = await apollo.query({
                query: gql`query {
                    patients{
                        id
                        name
                        surname
                        type
                        email
                        mobile
                        login
                        activities {
                            id
                            name
                            code
                        }
                    }
                }`
            });
            return (promise.data.patients as any[]).map<Party>(it => new Party(it));
        } catch (e:any) {
            // eslint-disable-next-line no-console
            console.log(e);
            eventBus.$emit('error', e.message);
            throw e;
        }
    }

    async createParty(person: Party, password: string) {

        const wp = new WriteParty({
            id: 0, name: person.name, surname: person.surname, login: person.login,
            password: password, email: person.email, mobile: person.mobile, type: person.type, activities: person.activities!!.map((it: Activity) => it.id)
        });
        try {
            let promise = await apollo.mutate(
                {
                    mutation: gql`mutation($writePerson: WriteParty!) {
                        createPerson(writeParty: $writePerson)
                    }`, variables: {writePerson: wp}
                }
            );
            return promise.data;
        } catch (e:any) {
            eventBus.$emit('error', e.message);
            throw e;
        }

    }

    async updateParty(person: Party, password: string | undefined) {
        if (utils.isNull(person.id)) {
            return false;
        }
        const wp = new WriteParty({
            id: person.id, name: person.name, surname: person.surname, login: person.login,
            password: password, email: person.email, mobile: person.mobile, type: person.type, activities: person.activities!!.map((it: Activity) => it.id),
            workingHours: person.workingHours
        });
        try {
            let promise = await apollo.mutate(
                {
                    mutation: gql`mutation($writeParty: WriteParty!) {
                        updatePerson(writeParty: $writeParty)
                    }`, variables: {writeParty: wp}
                }
            );
            return promise.data;
        } catch (e:any) {
            eventBus.$emit('error', e.message);
            throw e;
        }

    }

    async therapistById(therapistId: number) {
        let promise = await apollo.query({
            query: gql`query($therapistId: Int!) {
                therapistById(therapistId: $therapistId){
                    id
                    name
                    surname
                    email
                    mobile
                    login
                    activities{
                        id
                        name
                        code
                        description
                    }
                    workingHours{
                        mondayFrom
                        mondayTo
                        tuesdayFrom
                        tuesdayTo
                        wednesdayFrom
                        wednesdayTo
                        thursdayFrom
                        thursdayTo
                        fridayFrom
                        fridayTo
                        saturdayFrom
                        saturdayTo
                        sundayFrom
                        sundayFrom
                    }
                }
            }`,
            variables: {therapistId: therapistId}
        });
        // eslint-disable-next-line no-console
        console.log(promise.data.therapistById);
        return promise.data.therapistById;
    }

    async patientById(patientId: number) {
        let promise = await apollo.query({
            query: gql`query($patientId: Int!) {
                patientById(patientId: $patientId){
                    id
                    name
                    surname
                    email
                    mobile
                    login
                    activities{
                        id
                        name
                        code
                        description
                    }
                }
            }`,
            variables: {patientId: patientId}
        });
        return promise.data.patientById;
    }

    async allPatientsForActivity(activityId: number) {
        let promise = await apollo.query(
            {
                query: gql`query($activityId: Int!) {
                    patientsForActivity(activityId: $activityId) {
                        id
                        name
                        surname
                    }
                }`,
                variables: {activityId: activityId}
            }
        );
        return promise.data.patientsForActivity;
    }

    async allPatientsForActivityAndDateRange(activityId: number, dateFrom: string, timeFrom: string, duration: number) {
        let promise = await apollo.query(
            {
                query: gql`query($activityId: Int!, $dateFrom: LocalDate!, $timeFrom: LocalTime!, $duration: Int!) {
                    patientsForActivityAndDateRange(activityId: $activityId, dateFrom: $dateFrom, timeFrom: $timeFrom, duration: $duration) {
                        id
                        name
                        surname
                    }
                }`,
                variables: {activityId: activityId, dateFrom: dateFrom, timeFrom: timeFrom, duration: duration}
            }
        );
        return promise.data.patientsForActivityAndDateRange;
    }

    async allTherapistsForActivityAndDateRange(activityId: number, dateFrom: string, timeFrom: string, duration: number) {
        let promise = await apollo.query(
            {
                query: gql`query($activityId: Int!, $dateFrom: LocalDate!, $timeFrom: LocalTime!, $duration: Int!) {
                    therapistsForActivityAndDateRange(activityId: $activityId, dateFrom: $dateFrom, timeFrom: $timeFrom, duration: $duration) {
                        id
                        name
                        surname
                    }
                }`,
                variables: {activityId: activityId, dateFrom: dateFrom, timeFrom: timeFrom, duration: duration}
            }
        );
        return promise.data.therapistsForActivityAndDateRange;
    }
}

export default new PartyService();
